import React, { useRef, useState } from 'react';
import { LargeAutoComplete } from '@secretescapes/falcon';
import { useClickOutsideDetector } from '@utils/EventListeners.utils';
import { type Option } from './DropdownInput.interfaces';
import { Container } from './DropdownInput.styles';

interface Props {
  label: string;
  options: Option[];
  value: string;
  onSelect: (newValue: string) => void;
  isDisabled?: boolean;
}

export const DropdownInput = ({ label, options, value, onSelect, isDisabled }: Props) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLUListElement | null>(null);

  const handleClose = () => setOpen(false);

  useClickOutsideDetector([dropdownRef], handleClose, []);

  const handleClick = () => setOpen(true);
  const handleFocus = () => setOpen(true);

  const handleSelect = (newValue: string) => {
    onSelect(newValue);
    setOpen(false);
  };

  return (
    <Container>
      <LargeAutoComplete
        // @ts-expect-error TODO: Fix prop type in falcon
        autoCompleteListContainerRef={dropdownRef}
        id={label}
        label={label}
        name={label}
        open={open}
        dataSource={options}
        value={value}
        isAutoCompleteEnabled={true}
        isReadOnly={true}
        filterOption={false}
        highlightExactMatchOnly={true}
        onClick={handleClick}
        onFocus={handleFocus}
        onSelect={handleSelect}
        isDisabled={isDisabled}
      />
    </Container>
  );
};
